



















import { Vue, Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
import PushOrderUtils from '@/shared/utils/push-order-utils';

@Component
export default class PushOrderInfo extends Vue {
  @Prop({ required: false, default: '' }) pushOrderNumber!: string;

  @Prop({ required: false, default: '' }) pushOrderExpirationDate!: string;

  get getIcon() {
    return PushOrderUtils.getIcon();
  }

  get formattedPushOrderDate() {
    return this.pushOrderExpirationDate
      ? moment(this.pushOrderExpirationDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
      : '';
  }

  get pushOrderExpiredAlertColor() {
    return PushOrderUtils.getColor(this.pushOrderExpirationDate);
  }

  get getLegend() {
    return PushOrderUtils.getLegend(this.pushOrderExpirationDate);
  }
}
